import KeyMirror from 'keymirror';

module.exports = {
    ActionTypes: KeyMirror({
        UPDATE_ACCOUNT_SETTINGS: null
    }),
    accountSettingsModel: {
        accountHolderName: undefined,
        branchNumber: undefined,
        accountNumber: undefined,
        name: {
            givenName: undefined,
            lastName: undefined,
            title: undefined,
            gender: undefined,
            fullName: undefined
        }
    },
    accountSettingsRule: {
        accountHolderName: 'required|nameWithNumSpaces|maxLength:30',
        branchNumber: 'required|numeric2|exactLength:6',
        accountNumber: 'required|alphaNumWithSpaces|maxLength:9'
    },
    customAttributeName: {
        accountHolderName: 'name of account holder',
        branchNumber: 'branch number (BSB)',
        accountNumber: 'bank account number'
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/AccountSettingsConstants.js